<template>
  <div class="story">
    <div
      class="four wow animated fadeInUp"
      data-wow-duration="1s"
      data-wow-delay=".5s"
    >
      品牌故事
    </div>
    <div
      class="yi wow animated fadeInUp"
      data-wow-duration="2s"
      data-wow-delay=".5s"
    ></div>
    <div class="storyCenter">
      <div class="LR">
        <div
          class="Left wow animated fadeInUp"
          data-wow-duration="2s"
          data-wow-delay=".5s"
        >
          <p class="p1">{{ List.keyword_info }}</p>
          <p class="p2" v-html="List.describe" :title="List.describe"></p>
        </div>
        <div
          class="right wow animated fadeInUp"
          data-wow-duration="2s"
          data-wow-delay=".5s"
        >
          <img :src="JJImg.images" alt="" />
          <div class="background"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import { GetHF, GetIndex_Show } from "@/https/http";
export default {
  data() {
    return {
      List: "",
      JJImg: "",
    };
  },
  created() {
    GetHF().then((res) => {
      this.List = res.result;
      console.log(this.List)
    });
    GetIndex_Show().then((res) => {
      this.JJImg = res.result;
      console.log(this.JJImg,'测试')
    });
  },
  mounted() {
    window.addEventListener("scroll", this.windowScroll);
    this.$parent.color = `#000`;
    this.$parent.backgroundColor = "#fff";
    let wow = new WOW({
      boxClass: "wow", //需要执行动画的元素的 class
      animateClass: "animated", //animation.css 动画的 class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备上执行动画
      live: true, //异步加载的内容是否有效
    });
    wow.init();
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.story {
  width: 100%;
  height: 790px;

  min-width: 1440px;
  .four {
    width: 123px;
    height: 30px;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
    overflow: hidden;
    margin: 148px auto;
    margin-bottom: 19px;
  }
  .yi {
    width: 100px;
    height: 3px;
    background: linear-gradient(270deg, #fad126, #ff8229);
    border-radius: 0px;
    margin-top: 19px;
    margin: 0 auto;
  }
  .storyCenter {
    height: 450px;
    width: 1440px;
    margin: 0 auto;
    .LR {
      width: 1440px;
      height: 450px;
      float: left;
      margin-top: 91px;
      .Left {
        margin-top: 91px;
        margin-left: 101px;
        float: left;
      }
      .p1 {
        /* width: 217px; */
        height: 24px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #1a1a1a;
        line-height: 30px;
        margin-bottom: 43px;
      }
      .p2 {
        width: 538px;
        height: 197px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 36px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
      }

      .right {
        width: 600px;
        height: 400px;
        float: left;
        img {
          position: absolute;
          z-index: 1;
          margin-left: 128px;
          width: 548px;
          height: 400px;
        }
        .background {
          position: relative;
          top: -42px;
          left: 344px;
          width: 60%;
          height: 279.6px;
          background: #ff8229;
          border-radius: 20px;
        }
      }
    }
  }
}
</style>